export default __webpack_public_path__ + "static/media/launch-app-icon.bb6a9401.svg";